/* src/app/system-utils/side-panel-stepper/side-panel-stepper.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.panel-list-root {
  display: flex;
  flex-direction: row;
  height: 100%;
  border: solid 1px var(--tem-border);
  border-radius: 4px;
  position: relative;
  overflow-y: auto;
}
.panel-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  border-right: solid 1px var(--tem-border);
  position: relative;
  overflow: auto;
  direction: rtl;
}
.panel-list-item {
  padding: 20px 10px;
  border-bottom: solid 1px var(--tem-border);
  position: relative;
  font-weight: 500;
  cursor: pointer;
}
.item-selected {
  background-color: color-mix(in srgb, var(--tem-deep) 12%, transparent);
  width: 3px;
  height: 100%;
  right: 0;
  position: absolute;
  top: 0px;
}
.panel-list-item-wrapper-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.panel-list-item-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 10px;
  border-radius: 16px;
  padding: 10px;
  overflow: auto;
  border: solid 1px var(--tem-border);
}
.title-panel {
  width: 100%;
  font-size: large;
  font-weight: 500;
  margin-bottom: 6px;
}
.info {
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 15px;
  font-weight: 500;
  text-align: center;
  background-color: var(--tem-accent-soft);
}
.button-panel-list {
  width: 100%;
  height: 40px;
  margin-top: 4px;
}
actions-buttons {
  display: flex;
  flex-direction: column;
}
.as-horizontal > .as-split-area {
  padding: 0;
}
/*# sourceMappingURL=side-panel-stepper.component.css.map */
